/* ================================================================
   rq-drawer-fix.js

   The drawer fix itself now lives in assets/rq-drawer-fix.css. Read
   the note at the top of that file before changing anything here:
   the previous version of THIS file watched the drawer's class
   attribute and wrote a class of its own from the observer callback,
   which re-fired the observer, which wrote it again. Microtasks drain
   until empty, so the renderer never reached a paint. Opening the
   drawer hung the page. Do not reintroduce a MutationObserver that
   writes to the attribute it observes. If you ever must, guard every
   write with a contains() check first, the way pdp-sticky-atc.js
   does.

   What is left here is only what CSS cannot do:

   1. Clear a stale body.overflow-hidden scroll lock. Several modals
      on this store add it and can fail to remove it, which leaves
      the page unscrollable even when nothing is on screen. One
      querySelector every two seconds, and the class is only touched
      when it is actually present and nothing is open.

   2. The ?rqtap=1 on-device diagnostic. Add it to any URL on the
      phone and a panel pins to the top of the screen naming whatever
      element currently sits under the middle and edges of the
      viewport, with its position, z-index, visibility and
      pointer-events. Reproduce a dead screen, screenshot the panel,
      and the culprit is named rather than guessed at.

   The last-resort rescue for an unknown stuck overlay lives in
   assets/rq-tap-rescue.js. It used to be duplicated here too, which
   meant four forced layouts on every single tap. One copy only.
   ================================================================ */
(function () {
  'use strict';

  if (window.__rqDrawerFix) return;
  window.__rqDrawerFix = true;

  /* Everything on this store that may legitimately own the screen,
     including the two full-screen lightboxes defined inside
     main-product.liquid and product-showcase.liquid. */
  var OPEN_SELECTOR =
    'cart-drawer.active, .quick-add-modal[open], modal-dialog[open], ' +
    '.modal__content[open], details[open] > .menu-drawer, ' +
    '#mobile-gallery-overlay.active, #pshow-modal.active';

  function somethingOpen() {
    return document.querySelector(OPEN_SELECTOR);
  }

  function syncBody() {
    if (!document.body) return;
    if (!document.body.classList.contains('overflow-hidden')) return;
    if (somethingOpen()) return;
    document.body.classList.remove('overflow-hidden');
  }

  window.addEventListener('pageshow', syncBody);
  window.addEventListener('orientationchange', syncBody);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncBody();
  });
  setInterval(syncBody, 2000);

  /* ---- on-device diagnostic ---- */
  function describe(el) {
    if (!el) return '(none)';
    var cls = (el.className && el.className.toString ? el.className.toString() : '')
      .trim().split(/\s+/).slice(0, 3).join('.');
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + (cls ? '.' + cls : '');
  }

  function diagnostic() {
    var box = document.createElement('div');
    box.style.cssText =
      'position:fixed;left:0;right:0;top:0;z-index:2147483647;' +
      'background:#fff;color:#111;font:11px/1.4 monospace;padding:8px;' +
      'border-bottom:3px solid #ffc107;max-height:45vh;overflow:auto';
    document.body.appendChild(box);

    setInterval(function () {
      var w = window.innerWidth, h = window.innerHeight;
      var pts = [
        ['centre', w / 2, h / 2],
        ['upper', w / 2, h * 0.25],
        ['lower', w / 2, h * 0.8],
        ['left', w * 0.1, h / 2],
        ['right', w * 0.9, h / 2]
      ];

      var d = document.querySelector('cart-drawer');
      var out = 'body: ' + (document.body.className || '(none)') + '<br>' +
        'cart-drawer: ' + (d ? (d.className || '(no class)') : 'none') + '<br><hr>';

      for (var i = 0; i < pts.length; i++) {
        var el = document.elementFromPoint(pts[i][1], pts[i][2]);
        if (!el) { out += pts[i][0] + ': (none)<br>'; continue; }
        var cs = window.getComputedStyle(el);
        out += '<b>' + pts[i][0] + '</b>: ' + describe(el) +
          '<br>&nbsp;&nbsp;pos=' + cs.position +
          ' z=' + cs.zIndex +
          ' vis=' + cs.visibility +
          ' pe=' + cs.pointerEvents +
          ' op=' + cs.opacity + '<br>';
      }
      box.innerHTML = out;
    }, 1000);
  }

  if (location.search.indexOf('rqtap=1') > -1) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', diagnostic);
    } else {
      diagnostic();
    }
  }
})();
